import React from 'react'
import { ThemeProvider } from 'styled-components'

import theme from './src/config/theme'
import GlobalStyles from './src/styled/GlobalStyles'
import ModeProvider from './src/components/ModeProvider'

export const wrapRootElement = ({ element }) => (
  <ModeProvider>
    {mode => (
      <ThemeProvider
        theme={{
          ...theme,
          colors: theme.colors[mode],
        }}
      >
        <GlobalStyles mode={mode} />
        {element}
      </ThemeProvider>
    )}
  </ModeProvider>
)
